import { RedoBadge } from "@redotech/arbiter/badge/redo-badge";
import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Flex } from "@redotech/arbiter/flex";
import { useTranslation } from "@redotech/redo-i18n";
import { memo } from "react";

/** Marks an integration whose connection test is pending or failed, with an optional way to test it again. */
export const ConnectionNotVerifiedBadge = memo(
  function ConnectionNotVerifiedBadge({
    onTestAgain,
  }: {
    onTestAgain?: () => void;
  }) {
    const { t } = useTranslation();
    return (
      <Flex align="center" gap="sm">
        <RedoBadge color="gray" size="sm" text={t("Not verified")} />
        {onTestAgain && (
          <RedoButton
            hierarchy="link"
            onClick={onTestAgain}
            size="sm"
            text={t("Test again")}
          />
        )}
      </Flex>
    );
  },
);
